import React from "react";
import { Link } from "react-router-dom";
import "./common.css";

const classifiedData = [
  {
    _id: "s9012345678wxyz5713",
    name: "Tarkesh",
    email: "tarkesh@gmail.com",
    password: "TarkeshTarkesh",
    mobileNumber: "8826375131",
    companyName: "Mithila Handicrafts LLP",
    productOrService: "Glass Jar",
    imgSrc: "/assets/glass-jar.jpg",
    mainProducts: "Glass Jars, Handicrafts, Decorative Items",
    altText: "Glass Jar - Mithila Handicrafts LLP",
    years: "1 YRS",
    location: "Noida, India",
    tooltipText: "Mithila Handicrafts LLP, Noida, India",
    rating: "4.5",
    ratingPercent: "90%",
    ratingsCount: "130",
    responseRate: "88%",
    whatsappConfirmed: true,
  },
  {
    _id: "goel_timber_store",
    name: "Praveen",
    email: "praveen@gamil.com",
    password: "",
    mobileNumber: "9871256610",
    companyName: "M/S Goel Timber Store",
    productOrService: "Wall Mirror/Glass",
    imgSrc: "/assets/c.jpg",
    mainProducts: "Wall Mirror, Glass",
    altText: "Wall Mirror and Glass - M/S Goel Timber Store",
    years: "1 YRS",
    location: "Delhi, India",
    tooltipText: "M/S Goel Timber Store, Delhi, India",
    rating: "4.5",
    ratingPercent: "92%",
    ratingsCount: "180",
    responseRate: "85%",
    whatsappConfirmed: true,
  },

  // Add more items if needed
];

const GlassProducts = () => {
  return (
    <div className="main-box">
      <aside>
        <div className="flt-box-wrap">
          <div className="flt-box mb-0 flt-head">Filters By</div>
          <div className="flt-box bdrt-0">
            <p className="flt-title">Related Categories</p>
            <div className="flt-content">
              <ul className="flt-list cust-scroll">
                <li>
                  <Link to="#">Wall Art</Link>
                </li>
                <li>
                  <Link to="#">Decorative Mirrors</Link>
                </li>
                <li>
                  <Link to="#">Photo Frames</Link>
                </li>
                <li>
                  <Link to="#">Table Decor</Link>
                </li>
                <li>
                  <Link to="#">Lamps & Lighting</Link>
                </li>
                <li>
                  <Link to="#">Vases</Link>
                </li>
                <li>
                  <Link to="#">Clocks</Link>
                </li>
                <li>
                  <Link to="#">Decorative Items</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="flt-box">
            <p className="flt-title">By State</p>
            <div className="flt-content">
              <div className="flt-search">
                <input
                  type="text"
                  name="state_id"
                  placeholder="Search State"
                  id="state-search-input"
                />
              </div>
              <ul className="flt-list cust-scroll" id="state-lists">
                <li>
                  <Link to="#">All India</Link>
                </li>
                <li>
                  <Link to="#">Maharashtra</Link>
                </li>
                <li>
                  <Link to="#">Tamil Nadu</Link>
                </li>
                <li>
                  <Link to="#">Gujarat</Link>
                </li>
                <li>
                  <Link to="#">Madhya Pradesh</Link>
                </li>
                <li>
                  <Link to="#">Uttar Pradesh</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </aside>
      <main>
        <section className="section">
          <p className="sect-title">Explore by Categories</p>
          <div className="horprd expcatg" id="expcatg">
            <div className="item">
              <Link to="#">
                <div className="horprd-box">
                  <figure>
                    <img
                      src="/assets/deco1.jpg"
                      width={55}
                      height={55}
                      alt="Wall Art"
                    />
                  </figure>
                  <p className="title">Wall Art</p>
                </div>
              </Link>
            </div>
            <div className="item">
              <Link to="#">
                <div className="horprd-box">
                  <figure>
                    <img
                      src="/assets/decor2.webp"
                      width={55}
                      height={55}
                      alt="Decorative Mirrors"
                    />
                  </figure>
                  <p className="title">Decorative Mirrors</p>
                </div>
              </Link>
            </div>
            <div className="item">
              <Link to="#">
                <div className="horprd-box">
                  <figure>
                    <img
                      src="/assets/decor3.jpg"
                      width={55}
                      height={55}
                      alt="Photo Frames"
                    />
                  </figure>
                  <p className="title">Photo Frames</p>
                </div>
              </Link>
            </div>
            <div className="item">
              <Link to="#">
                <div className="horprd-box">
                  <figure>
                    <img
                      src="/assets/decor3.webp"
                      width={55}
                      height={55}
                      alt="Table Decor"
                    />
                  </figure>
                  <p className="title">Table Decor</p>
                </div>
              </Link>
            </div>
            <div className="item">
              <Link to="#">
                <div className="horprd-box">
                  <figure>
                    <img
                      src="/assets/decor5.jpg"
                      width={55}
                      height={55}
                      alt="Lamps & Lighting"
                    />
                  </figure>
                  <p className="title">Lamps & Lighting</p>
                </div>
              </Link>
            </div>
          </div>
        </section>
        <ul className="classfied-wrap">
          {classifiedData.map((item, index) => (
            <li key={index}>
              <div className="classified">
                <div className="prd-info">
                  <div className="prd-box">
                    <img
                      src={item.imgSrc}
                      alt={item.altText}
                      width={250}
                      height={250}
                    />
                  </div>
                </div>
                <div className="cinfo">
                  <div className="cbox">
                    <figure>
                      <span className="cmp-year">{item.years}</span>
                    </figure>
                    <div className="cboxr">
                      <Link to={item.path}>
                        <h4 className="title">{item.companyName}</h4>
                      </Link>
                      <p className="cloc tooltip ellipsis">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={16}
                          height={16}
                          fill="currentColor"
                          className="bi-location"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                        </svg>
                        {item.location}
                        <span className="tooltiptext">{item.tooltipText}</span>
                      </p>
                      <div className="rating-wrap">
                        <span className="rtbox">{item.rating}</span>
                        <span
                          className="crate"
                          style={{ "--_score": item.ratingPercent }}
                        />
                        <span className="rate-text">
                          {item.ratingsCount} Ratings
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="caddit">
                    <div className="item">
                      <div
                        className="ca-box modal-btn"
                        data-modal="motc"
                        data-src={item.trustCertificateUrl}
                      >
                        <p>
                          <i className="l3icon motc-icon" />
                        </p>
                      </div>
                    </div>
                    <div className="item">
                      <div className="ca-box">
                        <p>
                          <i className="l3icon resp-icon" />
                        </p>
                        <p>
                          <span>Response Rate</span> <b>{item.responseRate}</b>
                        </p>
                      </div>
                      <p>
                        <span>Main Products</span> <b>{item.mainProducts}</b>
                      </p>
                    </div>
                  </div>
                  <div className="caction">
                    <Link to={"/register-buyer"}>
                      <p>Contact Supplier</p>
                    </Link>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </main>
    </div>
  );
};

export default GlassProducts;
